import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Submit, Button } from 'shared/components/Form';
import CloseButton from 'shared/components/buttons/Close';
import styles from './ConfirmModal.module.scss';

const ConfirmModal = ({
  title,
  content,
  confirmLabel,
  onConfirm,
  closeLabel,
  onClose,
  rejectLabel,
  onReject,
  size,
  opened,
  returnFocusAfterClose,
  noContentMargin,
  wrapperClassName,
}) => (
  <Modal
    wrapClassName={wrapperClassName}
    size={size}
    isOpen={opened}
    toggle={onClose}
    centered
    returnFocusAfterClose={returnFocusAfterClose}
  >
    {title && (
      <ModalHeader close={onClose ? (<CloseButton onClick={onClose}>{closeLabel}</CloseButton>) : undefined}>
        {title}
      </ModalHeader>
    )}
    <ModalBody>
      <div className={cn(styles.content, { [styles.noContentMargin]: noContentMargin })}>
        {content}
      </div>
    </ModalBody>
    <div className={cn(styles.buttons, styles[confirmLabel && rejectLabel ? 'twoButtons' : 'oneButton'])}>
      {rejectLabel && onReject && (
        <Button title={rejectLabel} onClick={onReject} />
      )}
      {confirmLabel && onConfirm && (
        <Submit title={confirmLabel} onClick={onConfirm} />
      )}
    </div>
  </Modal>
);

ConfirmModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  opened: PropTypes.bool,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  closeLabel: PropTypes.string,
  onClose: PropTypes.func,
  rejectLabel: PropTypes.string,
  onReject: PropTypes.func,
  returnFocusAfterClose: PropTypes.bool,
  noContentMargin: PropTypes.bool,
  wrapperClassName: PropTypes.string,
};

ConfirmModal.defaultProps = {
  title: null,
  content: null,
  size: 'md',
  opened: false,
  confirmLabel: null,
  onConfirm: null,
  closeLabel: null,
  onClose: null,
  rejectLabel: null,
  onReject: null,
  returnFocusAfterClose: false,
  noContentMargin: false,
  wrapperClassName: null,
};

export default ConfirmModal;
